export const ACT_DISCONTINUE = 'discontinue';
export const ACT_EMAIL_HISTORY = 'emailHistory';
export const ACT_REASSIGN = 'reassign';
export const ACT_EXPORT = 'export';
export const ACT_VIEW = 'view';

// Reorder actions to set the default order
export const ACTION_BUTTONS_MAP = {
  [ACT_DISCONTINUE]: 'Cancel',
  [ACT_EMAIL_HISTORY]: 'Email History',
  [ACT_REASSIGN]: 'Reassign',
  [ACT_EXPORT]: 'Export',
  [ACT_VIEW]: 'View',
};
